import React, { useContext, useEffect } from 'react';
import './index.scss';
import Illustration from 'assests/svg/Illust.svg';
import ThankYouCheckIcon from 'assests/svg/thankyou-check.svg';
import Button from 'b2b-ui-components-lib/lib/components/button';
import Config from 'config/config';
import { findParamFromUrl, getFromSessionStorage, removeFromSessionStorage, navigateTo, removeUserSessionData } from 'common/utils/app.utils';
import { SESSION_STORAGE, LEAD_STATUS } from 'home/view/upgrade-order/constants';
import { redirectToTMO, fsThankYouOnLoad } from 'home/view/upgrade-order/utils';
import { CONTEXT } from 'home/view/upgrade-order/context';
import useDetectURLChange from 'home/view/upgrade-order/hooks';

const ThankYouPage = (props) => {
  const { leadData = {}, orderDetail = {}, showCancelPage = false } = props;

  const { setPnqToken, setKycToken, userType, history } = useContext(CONTEXT);

  const leadStatus = leadData && leadData.leadStatus;
  const leadId = leadData && leadData.leadId;

  const orderId = getFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.ORDER_ID) || (orderDetail && orderDetail.orderId) || findParamFromUrl('orderId', false);

  // clear user session data
  useDetectURLChange(removeUserSessionData);

  useEffect(() => {
    fsThankYouOnLoad(leadData, userType, showCancelPage);
  }, [leadData, userType, showCancelPage]);

  const getCancelledId = () => {
    if (leadStatus === LEAD_STATUS.KYC_IN_PROGRESS || leadStatus === LEAD_STATUS.ORDER_CANCELLED) {
      return orderId;
    }

    return leadId;
  };

  const handleRedirectToHome = () => {
    navigateTo(Config.aehHomePage);
    removeFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.PNQ_AUTH_TOKEN);
    removeFromSessionStorage(SESSION_STORAGE.MODULE_ID, SESSION_STORAGE.KYC_AUTH_TOKEN);
    setPnqToken('');
    setKycToken('');
  };

  return (
    <React.Fragment>
      <div className="single_upgrade_thanksSection">
        <div className="thanks-container">
          <div className="thanks">
            <div className="thanksContent">
              {!showCancelPage && (
                <React.Fragment>
                  <img src={ThankYouCheckIcon} alt="check-icon" />
                  <h2 className="title">Thank you!</h2>
                  <h2 className="sub-title">Request raised successfully.</h2>
                  <p className="content">
                    The change order request{' '}
                    <b>
                      ID{' '}
                      <a
                        href="javascript:void(0)"
                        onClick={() => redirectToTMO(false, orderId)}
                        style={{
                          color: '#cc000a'
                        }}
                      >
                        {orderId}
                      </a>
                    </b>{' '}
                    has been raised. You will also receive an email with the summary of this order request.
                  </p>
                </React.Fragment>
              )}
              {showCancelPage && (
                <React.Fragment>
                  <h2 className="sub-title cancelled">Request is cancelled.</h2>
                  <p className="content cancelled">
                    The change order request <b>ID {getCancelledId()}</b> has been cancelled.
                  </p>
                </React.Fragment>
              )}
              <div className="buttonSection">
                <a href="javascript:void(0)">
                  <Button onClick={handleRedirectToHome}> BACK TO HOME</Button>
                </a>
                {!showCancelPage && (
                  <a href="javascript:void(0)">
                    <Button onClick={() => redirectToTMO(true)}>TRACK ORDER</Button>
                  </a>
                )}
              </div>
            </div>

            <img src={Illustration} alt="thank-you" />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ThankYouPage;
